import { Component, Input, Output   } from '@angular/core'; 
import { NgxPaginationModule } from 'ngx-pagination';

import { DebtService } from '../_Services/debt.service';
import { CommonService } from '../_Services/common.service';
import { Router, ActivatedRoute } from '@angular/router'; 

@Component({
  templateUrl: 'agencyassignment.component.html'
})
export class AgencyassignmentComponent {

    debts = [];  
    agency_id: Number;

    model: any = {product: ''};

    p: any = 1;  
    paginator = []; 

    agent = []; 

	constructor(private router: Router, private route:ActivatedRoute, private debtService: DebtService) { }

    changeShape(shape){ 
        this.model.product = shape;
    } 

    pageChanged(page: Number) {
        if(page == undefined) {
            page = 1;
        }
        this.p = page; 
        this.agency_id = this.route.snapshot.params['id']; 
        this.debtService.getAgencyAssignment(this.agency_id, page, this.model).subscribe(result => {
                console.log(result.agent);
                this.debts = result.assignments;
                this.paginator = result.paginator; 
                this.agent = result.agent.Agency; 
            });
    }

	ngOnInit() { 
		this.agency_id = this.route.snapshot.params['id']; 
	    this.debtService.getAgencyAssignment(this.agency_id, this.p, null).subscribe(result => {
                
                this.debts = result.assignments;
                this.paginator = result.paginator;
                this.agent = result.agent.Agency; 

                console.log(this.agent);
            }); 
	}
}


// WEBPACK FOOTER //
// ./src/app/agencies/agencyassignment.component.ts